module.exports = __webpack_public_path__ + "img/logo_small.9c77799a.png";